import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@ngneat/transloco';
import { LoadingBoxModule } from '@shared/components/loading-box';
import { DynamicReportGeneralPreviewComponent } from './dynamic-report-general-preview.component';
import { RedPaginationModule } from '@redoc-starter/redoc';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellValueFmtPipe, ExceljsTableComponent } from '@shared/components/exceljs-viewer';
import { ExceljsParameterComponent } from '@shared/components/exceljs-viewer';
import { ExceljsWorkbookComponent } from 'libs/shared/components/exceljs-viewer/src/lib/exceljs-workbook/exceljs-workbook.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExceljsViewerModule } from '@shared/components/exceljs-viewer';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { VirtualScrollControllerModule } from '@shared/components/virtual-scroll-controller';
import { ExceljsWorksheetComponent } from 'libs/shared/components/exceljs-viewer/src/lib/exceljs-worksheet/exceljs-worksheet.component';
import { CollWidthPipe } from 'libs/shared/components/exceljs-viewer/src/lib/exceljs-col-width.pipe';
import { RouterModule } from '@angular/router';
import { ExceljsVirtualScrollControllerDirective } from 'libs/shared/components/exceljs-viewer/src/lib/exceljs-virtual-scroll-controller.directive';
import { ExceljsCellHyperlinkComponent } from 'libs/shared/components/exceljs-viewer/src/lib/exceljs-cell-hyperlink/exceljs-cell-hyperlink.component';
import { ClearEnterDirective } from 'libs/shared/components/exceljs-viewer/src/lib/exceljs-table/normalized-text.directive';
import { ToastModule } from '@shared/components/toast';
import { NoDataModule } from '@shared/components/no-data';


const materialModules = [
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatTabsModule,
    CellValueFmtPipe,
    CollWidthPipe,
    RouterModule,
    ExceljsVirtualScrollControllerDirective,
    ExceljsCellHyperlinkComponent,
    ClearEnterDirective,
];

const sharedModules = [
    LoadingBoxModule,
    RedPaginationModule,
    ExceljsViewerModule,
    ExceljsTableComponent,
    ExceljsWorkbookComponent,
    ExceljsParameterComponent,
    VirtualScrollControllerModule,
    ScrollingModule,
    ExceljsWorksheetComponent,
    ToastModule,
    NoDataModule
];

@NgModule({
    declarations: [DynamicReportGeneralPreviewComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ...materialModules,
        ...sharedModules,
        TranslocoModule
    ],
    exports: [DynamicReportGeneralPreviewComponent],
})
export class DynamicReportGeneralPreviewModule { } 